import React from "react";
import Card from "components/card";
import { BookOpen } from "lucide-react";
import { STAFF_STATUS_COLORS } from "variables/constants";
import Badge from "components/badge";
import CrudOption from "components/dropdown/crudoption";

const TrainingModuleCard = ({
    recordData,
    showStat = true,
    showResult = false,
    deleteHandler=null,
}) => {
    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border border-slate-200">
            <div className="p-6">
                <div className="grid md:grid-cols-12 gap-4">
                    <div className="md:col-span-4">
                        <div className="flex items-start gap-3 mb-2">
                            <div className="p-2 rounded-lg bg-gradient-to-br from-green-500 to-purple-600">
                                <BookOpen className="w-5 h-5 text-white" />
                            </div>
                            <div className="flex-1">
                                <h3 className="font-semibold mb-1">
                                    {recordData?.trm_title || recordData?.module_name}
                                </h3>
                                <p className="text-[12px] text-slate-700 mb-2">
                                    {recordData?.training_module?.trm_description || recordData?.trm_description}
                                </p>
                            </div>
                        </div>
                    </div>
                    {(showStat && 
                        <>
                            <div className="md:col-span-6">
                                <div className="grid grid-cols-3 gap-4">
                                    <div>
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Question Items
                                        </p>
                                        <p className="text-[18px] font-semibold text-blue-600">
                                            {recordData?.trm_question_items}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Passing Score
                                        </p>
                                        <p className="text-[18px] font-semibold text-green-600">
                                            {recordData?.passing_score}
                                        </p>
                                    </div>
                                    <div>
                                        <p className="text-[11px] text-slate-700 mb-1">
                                            Allowed Attempt
                                        </p>
                                        <p className="text-[18px] font-semibold text-orange-600">
                                            {recordData?.trm_allowed_attempt}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="md:col-span-1">
                                <p className="text-[11px] text-slate-700 mb-2">
                                    Status
                                </p>
                                <Badge color={STAFF_STATUS_COLORS[recordData?.trm_status_name]}>
                                    <span>{recordData?.trm_status_name}</span>
                                </Badge>
                            </div>
                            <div className="md:col-span-1">
                                <p className="text-[11px] text-slate-700 mb-2">
                                    Action
                                </p>
                                <CrudOption baseRoute="/console/training-modules" recordId={recordData?.trm_id} deleteHandler={deleteHandler}/>
                            </div>
                        </>
                    )}

                    {(showResult && 
                        <div className="md:col-span-8">
                            <div className="grid grid-cols-6 gap-4">
                                <div className="col-span-2">
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Participant Name
                                    </p>
                                    <p className="text-[18px] font-semibold text-blue-600">
                                        {recordData?.participant_name}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Passing Score
                                    </p>
                                    <p className="text-[18px] font-semibold text-green-600">
                                        {recordData?.training_module?.passing_score}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Final Score
                                    </p>
                                    <p className="text-[18px] font-semibold text-green-600">
                                        {recordData?.trs_score}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Attempt
                                    </p>
                                    <p className="text-[18px] font-semibold text-orange-600">
                                        {recordData?.trs_attempt}
                                    </p>
                                </div>
                                <div className="inline-block mr-6">
                                    <p className="text-[11px] text-slate-700 mb-1">
                                        Result
                                    </p>
                                    <p
                                        className={`text-[18px] font-semibold ${
                                            recordData?.trs_is_passed ? "text-green-600" : "text-red-600"
                                        }`}
                                    >
                                        {recordData?.trs_is_passed ? "Passed" : "Failed"}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
};

export default TrainingModuleCard;